var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageFillIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 0H14.25C16.32 0 18 1.68 18 3.75V14.25C18 16.32 16.32 18 14.25 18H3.75C1.68 18 0 16.32 0 14.25V3.75C0 1.68 1.68 0 3.75 0ZM14.25 1.5H3.75C2.51 1.5 1.5 2.51 1.5 3.75V9.9L3.41 8.46H3.43C4.55 7.71 6.05 7.89 6.97 8.88C8.44 10.47 10.07 11.71 12 11.71C13.93 11.71 15.19 11.02 16.47 9.74C16.48 9.72 16.5 9.71 16.5 9.71V3.75C16.5 2.51 15.49 1.5 14.25 1.5Z",
    fill: "#1F4E87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFillIcon);
export default __webpack_public_path__ + "static/media/image-fill-icon.b625b638a6e0dc9e1983ab6ba3d50690.svg";
export { ForwardRef as ReactComponent };